module.exports = __webpack_public_path__ + "static/media/theta.f366ef9d.svg";